









































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import FormValidator from "@/mixins/FormValidator";
import RedStar from "@/components/ui/RedStar.vue";
import { BaseModule } from "@/store/base.module";
import moment from "moment";
import { DalModule } from "@/store/dal.module";
import GlobalMixin from "@/mixins/GlobalMixin";
@Component({
  components: { MonthPicker, RedStar },
})
export default class AddAccountView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
  FormValidator,
  GlobalMixin,
) {
  formRef = "formAddAccount";
  account_id: number = null as any;
  summ: string = null as any;
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };

  async addAccount() {
    try {
      if (!this.validateForm()) return;

      BaseModule.setLoadingStatus(true);

      // все проверки выполняются на сервере, по reason показываем сообщение
      const res = await DalModule.addNewAccount({
        AccountId: this.account_id,
        Year: moment(this.period.to).year(),
        Month: moment(this.period.to).month() + 1,
        lastPaySum: this.summ,
      });
      if (res?.result !== true) {
        BaseModule.showMessage({
          message: this.getAddAccountError(res),
          color: "error",
        });
        return;
      }

      await DalModule.getAccounts();
      if (DalModule.accounts && DalModule.accounts.length == 1) {
        DalModule.setAccountId(DalModule.accounts[0].account_id);
      }
      this.$router.push({ name: "account-list" });
    } finally {
      BaseModule.setLoadingStatus(false);
    }
  }

  getAddAccountError(res: any): string {
    switch (res?.reason) {
      case "account-exists":
        return this.$t("account-info.account-exists").toString();
      case "invalid-data":
        return this.$t("account-info.add-invalid-data").toString();
      case "too-many-attempts":
        return this.$t("account-info.add-too-many-attempts", {
          minutes: res.retryAfterMinutes,
        }).toString();
    }
    return this.$t("account-info.add-error").toString();
  }

  async mounted() {
    const today = new Date();
    this.period.to = moment(today).format("YYYY-MM");
    this.period.min = moment(today)
      .add(-11, "M")
      .format("YYYY-MM");
    this.period.max = moment(today).format("YYYY-MM");
  }
}
